import { actionBuilder } from '../../functions/redux';
import * as type from './types';

export const alert = actionBuilder(type.ALERT_REQ);
export const removeAlert = actionBuilder(type.ALERT_CLOSE);
export const loading = actionBuilder(type.ALERT_LOADING);
export const loadingClose = actionBuilder(type.ALERT_LOADING_CLOSE);
